<div class="shopping-cart-icon">
    <mat-icon (click)="clickToCart()">add_shopping_cart</mat-icon>
    <div class="total-quantity">
        <p *ngIf="totalQuantity > 0">{{ totalQuantity }}</p>
    </div>
</div>
<div class="shopping-cart-icon-mobile">
    <mat-icon (click)="clickToCartMobile()">add_shopping_cart</mat-icon>
    <div class="total-quantity-mobile">
        <p *ngIf="totalQuantity > 0">{{ totalQuantity }}</p>
    </div>
</div>
<div *ngIf="isShoppingcartIconClicked" class="shopping-materials">
    <div class="shopping-cart-main">
        <div class="cart-and-sum">
            <div class="sum">
                <mat-icon class="close-button" (click)="closeCart()">close</mat-icon>
                <h4>{{"shoppingCart.cart" | translate}}: {{ totalQuantity }} db könyv</h4>
                <h4>{{"shoppingCart.total" | translate}}: {{ totalPrice | currency : 'Ft': 'symbol' : '1.0-0' }}</h4>
            </div>
            <div *ngIf="totalQuantity>0" class="back-or-pay">
                <button (click)="goToPay()">{{"shoppingCart.goToPayFromCart" | translate}}</button>
            </div>
        </div>
        <div *ngIf="materials.length>0"class="shopping-cart-books">
            <div [ngStyle]="material.packageName ? { background: '#ededed' } : { background: 'none' }" *ngFor="let material of materials; let i = index" class="shopping-cart-main-container">
                <div  *ngIf="material.quantity! > 0 && i < materials.length-1" class="shopping-cart-container">
                    <div class="shopping-material-content">
                        <img src="{{ material.url }}" />
                        <b *ngIf="material.packageName">{{material.packageName}} csomag</b>
                        <b *ngIf="material.hasPreorder">Előrendelés</b>
                        <label>{{ material.author }}</label>
                        <label>{{ material.title }}</label>
                    </div>
                    <div *ngIf="material.quantity! > 0 && i < materials.length-1" class="delete-button-container">
                        <button *ngIf="!material.packageName" class="delete-button" (click)="removeItem(material)"><mat-icon>close</mat-icon></button>
                        <button *ngIf="material.firstElementOfPackage" class="delete-button" (click)="loadRemovePackagePopup(material,'500ms','200ms')"><mat-icon>close</mat-icon></button>
                        <label *ngIf="!material.packageName">{{"shoppingCart.quantitySumPiece" | translate}}</label>
                        <div *ngIf="!material.packageName" class="plus-minus-button">
                            <button (click)="decreaseItemQuantity(material)" class="minus-button">-</button>
                            <p>{{ material.quantity }}</p>
                            <button (click)="increaseItemQuantity(material)" class="plus-button">+</button>
                        </div>
                        <p *ngIf="material.packageName">{{ material.quantity }} db</p>
                        <div class="item-quantity">
                            <label *ngIf="material.discountLimitedUntil != null">Kötött ár: </label><br>&nbsp;
                            <p>{{ material.originalPrice! * material.quantity! | currency : 'Ft': 'symbol' : '1.0-0' }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div [ngStyle]="material.packageName ? { background: '#ededed' } : { background: 'none' }" *ngFor="let material of materials; let i = index" class="shopping-cart-container-last">
                <div *ngIf="material.quantity! > 0 && i == materials.length-1" class="shopping-material-content">
                    <img src="{{ material.url }}" />
                    <b *ngIf="material.packageName">{{material.packageName}} csomag</b>
                    <b *ngIf="material.hasPreorder">Előrendelés</b>
                    <label>{{ material.author }}</label>
                    <label>{{ material.title }}</label>
                </div>
                <div *ngIf="material.quantity! > 0 && i == materials.length-1" class="delete-button-container">
                    <button *ngIf="!material.packageName" class="delete-button" (click)="removeItem(material)"><mat-icon>close</mat-icon></button>
                    <button *ngIf="material.firstElementOfPackage" class="delete-button" (click)="removeItem(material)"><mat-icon>close</mat-icon></button>
                    <label *ngIf="!material.packageName">{{"shoppingCart.quantitySumPiece" | translate}}</label>
                    <div *ngIf="!material.packageName" class="plus-minus-button">
                        <button (click)="decreaseItemQuantity(material)" class="minus-button">-</button>
                        <p>{{ material.quantity }}</p>
                        <button (click)="increaseItemQuantity(material)" class="plus-button">+</button>
                    </div>
                    <p *ngIf="material.packageName">{{ material.quantity }} db</p>
                    <div class="item-quantity">
                        <label *ngIf="material.discountLimitedUntil != null">Kötött ár: </label><br>&nbsp;
                        <p>{{ material.originalPrice! * material.quantity! | currency : 'Ft': 'symbol' : '1.0-0' }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
